<div nz-row nzGutter="25">
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div class="bg-white dark:bg-white/10 mb-[25px] p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Basic</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-collapse-basic></nz-demo-collapse-basic>
      </div>
    </div>
    <div class="bg-white dark:bg-white/10 mb-[25px] p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Nested panel</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-collapse-mix></nz-demo-collapse-mix>
      </div>
    </div>
    <div class="bg-white dark:bg-white/10 mb-[25px] p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">No Arrow</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-collapse-noarrow></nz-demo-collapse-noarrow>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div class="bg-white dark:bg-white/10 mb-[25px] p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Accordion</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-collapse-accordion></nz-demo-collapse-accordion>
      </div>
    </div>
    <div class="bg-white dark:bg-white/10 mb-[25px] p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Borderless</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-collapse-borderless></nz-demo-collapse-borderless>
      </div>
    </div>
    <div class="bg-white dark:bg-white/10 mb-[25px] p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Custom Panel</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-collapse-custom></nz-demo-collapse-custom>
      </div>
    </div>
  </div>
</div>

